import React from "react";
import Link from "gatsby-link";
import get from "lodash/get";
import Helmet from "react-helmet";
import styled from "styled-components";

import Slugline from "../components/slugline";
import { rhythm, scale } from "../utils/typography";
import bios from "../bios";

const TitleRow = styled.div`
  display: flex;
`;

const ImgContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin-right: ${rhythm(0.5)};
`;

const TitleContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
`;

const Header = styled.div`
  font-size: 22px;
  font-weight: bold;
`;

const ImageRow = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
`;

const MoreRow = styled.div`
  text-align: right;
  font-size: 12px;
`;

class BlogIndex extends React.Component {
  render() {
    const siteTitle = get(this, "props.data.site.siteMetadata.title");
    const posts = get(this, "props.data.allMarkdownRemark.edges");

    return (
      <div>
        <Helmet title={siteTitle} />
        <div style={{ marginBottom: rhythm(0) }}>
          <hr />
        </div>
        {posts.map(({ node }) => {
          const title = get(node, "frontmatter.title") || node.fields.slug;
          const author = get(node, "frontmatter.author");
          const bioObj = author && bios[author];
          return (
            <div key={node.fields.slug}>
              <TitleRow>
                <ImgContainer>
                  <img
                    src={bioObj.img}
                    style={{
                      border: "1px solid #cccccc",
                      borderRadius: "100%",
                      marginBottom: 0,
                      maxHeight: "50px"
                    }}
                  />
                </ImgContainer>
                <TitleContainer>
                  <Header>
                    <Link style={{ boxShadow: "none" }} to={node.fields.slug}>
                      {title}
                    </Link>
                  </Header>
                </TitleContainer>
              </TitleRow>

              <small>{node.frontmatter.date}</small>
              <p
                dangerouslySetInnerHTML={{ __html: node.excerpt }}
                style={{ marginBottom: rhythm(0.25) }}
              />
              <ImageRow>
                {node.frontmatter.cover_images && node.frontmatter.cover_images.map(a => {
                  const img = this.props.data.allImageSharp.edges.find(
                    e => e.node.original.src === a.publicURL
                  );
                  return (
                    <div key={a.publicURL} style={{ marginBottom: "10px" }}>
                      <Link style={{ boxShadow: "none" }} to={node.fields.slug}>
                        <img
                          style={{
                            marginBottom: "0px",
                            border: "1px solid #111111",
                          }}
                          src={img.node.resolutions.src}
                        />
                      </Link>
                    </div>
                  );
                })}
              </ImageRow>
              <MoreRow>
                <div>
                  <Link style={{ boxShadow: "none" }} to={node.fields.slug}>
                    (more...)
                  </Link>
                </div>
              </MoreRow>
            </div>
          );
        })}
      </div>
    );
  }
}

export default BlogIndex;

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
      }
    }
    allImageSharp {
      edges {
        node {
          resolutions(width: 180) {
            src
            width
            height
          }
          original {
            src
          }
        }
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD MMMM, YYYY")
            title
            author
            cover_images {
              id
              publicURL
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js